var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdv4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 68,
    viewBox: "0 0 83 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83439 31.0247L1.88689 30.8271L1.83178 30.6301L0.75 26.764V23.3261C0.75 21.3284 2.31289 19.75 4.19112 19.75H42.1602C44.0384 19.75 45.6012 21.3284 45.6012 23.3261V26.7521L44.4942 30.2804L44.4306 30.4832L44.4828 30.6891L45.6012 35.1031V46.6932C45.6012 48.6909 44.0384 50.2694 42.1602 50.2694H4.19112C2.31292 50.2694 0.75 48.6909 0.75 46.6932V35.1075L1.83439 31.0247Z",
    fill: "white",
    stroke: "#020288",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.8677H46.3512V35.0104H0V26.8677Z",
    fill: "#020288"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4336 44.4958C60.5289 37.7389 55.9393 31.3735 49.1824 30.2781C42.4256 29.1828 36.0601 33.7724 34.9647 40.5293C33.8694 47.2861 38.459 53.6516 45.2159 54.747C51.9727 55.8423 58.3382 51.2527 59.4336 44.4958Z",
    fill: "#FF010B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9053 47.0151L51.6084 36.312L53.1967 37.9003L42.4936 48.6034L40.9053 47.0151Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3351 40.9851C44.6312 40.9851 45.6818 39.9344 45.6818 38.6383C45.6818 37.3422 44.6312 36.2915 43.3351 36.2915C42.039 36.2915 40.9883 37.3422 40.9883 38.6383C40.9883 39.9344 42.039 40.9851 43.3351 40.9851Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0919 48.7419C52.388 48.7419 53.4387 47.6912 53.4387 46.3951C53.4387 45.099 52.388 44.0483 51.0919 44.0483C49.7958 44.0483 48.7451 45.099 48.7451 46.3951C48.7451 47.6912 49.7958 48.7419 51.0919 48.7419Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdv4);
export default __webpack_public_path__ + "static/media/adv_4.661ca3f750af638e6c32da22358b5777.svg";
export { ForwardRef as ReactComponent };